import { useState } from "react";
import './menus.css';
import { useNavigate } from "react-router-dom";
import { Accordion, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function T8_logistics({setactivity, permission, activeItem}) {
  const [isProductionOpen, setProductionOpen] = useState(true); // Predeterminadamente abierto
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };
  return (
    (
      <Accordion.Item eventKey="1">
        <Accordion.Header>
          <span role="img" aria-label="logistics">🚚</span> Operaciones
        </Accordion.Header>
        <Accordion.Body className="p-0">
          <Nav className="flex-column">
            {permission === '1' && (
              <Nav.Link active={activeItem === 'despachos'} style={activeItem === 'despachos' ? activeStyles : undefined} onClick={() => navigate('/Despachos')}>Despachos</Nav.Link>
            )}
          </Nav>
        </Accordion.Body>
      </Accordion.Item>
    )
  );
}

export default T8_logistics;
